import React, { Component } from 'react'
import { H1, Div, P, A } from '@driftt/tide-core'

import './styles.css'


class Goodbye extends Component {

  componentDidMount = () => {
    const { hideLoginStep } = this.props
    hideLoginStep()
  }

  onClickChatWithUs = () => {
    analytics.track && analytics.track('billing - account delete chat with us clicked', {})
    window.drift && window.drift.api.openChat()
  }

  render() {
    return (
      <Div className="goodbye-contents">
        <H1>Your account was deleted</H1>
          <Div className="goodbye-message">
            <P>
              Thank you so much for being a Drift customer 💙  We appreciate the opportunity to help your business.
            </P>
            <P>
              If you need to access your account again, <A onClick={this.onClickChatWithUs}>chat with us</A>.
            </P>
          </Div>
      </Div>
    )
  }
}

export default Goodbye


// WEBPACK FOOTER //
// ./src/components/pages/Login/Goodbye/index.js